module.exports = "/img/_/_/_/assets/images/card/type//shield.png?2fb74a7d759c46cd9c98135dec14610d";